import { API_V1 } from 'API/APIs/APIv1';
import _ from 'lodash';
import Logger from 'logger';

export const createProjectWrapper = async (name: string, projectType: 'normal' | 'li_search', projectIds: string[]) => {
  try {
    const response = await API_V1.post('/projects/wrappers', {
      projectWrapperName: name,
      projectType,
      projectIds,
    });
    return response.data;
  } catch (e) {
    Logger.trace('Error while creating a new project wrapper!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};

export const getProjectsFromWrapper = async (wrapperId: string) => {
  try {
    const response = await API_V1.get(`/projects/wrappers/${wrapperId}`);

    return response.data;
  } catch (e) {
    Logger.trace('Error while getting projects from project wrapper!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

const getParams = (projectType?: 'normal' | 'li_search', page?: number, total?: number, searchParam?: string) => {
  const paramObj: any = {};
  if (!_.isNil(projectType)) {
    paramObj.projectType = projectType;
  }
  if (!_.isNil(page) && !_.isNil(total)) {
    paramObj.limit = total;
    paramObj.offset = page * total;
  }
  if (!_.isNil(searchParam) && searchParam !== '') {
    paramObj.q = searchParam;
  }

  return paramObj;
};

export const getAllProjectWrappers = async (
  projectType?: 'normal' | 'li_search',
  page?: number,
  total?: number,
  searchParam?: string
) => {
  try {
    const response = await API_V1.get('/projects/wrappers', {
      params: getParams(projectType, page, total, searchParam),
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while getting all project wrappers!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const deleteProjectWrapper = async (wrapperId: string) => {
  try {
    const response = await API_V1.delete(`/projects/wrappers/${wrapperId}`);

    return response.data ?? { success: true };
  } catch (e) {
    Logger.trace('Error while getting all project wrappers!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};
